import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../config/envs';
import { generateTraceId } from './index';
import { mapJussubSubscription } from './subscriptionJussubMapper';
import { mapJusbillSubscription } from './subscriptionJusbillMapper';

const base = process.env.REACT_APP_API_URL;

export const getClientSubscriptionV2 = async (clientId) => {
  const response = await axios.get(`${base}/v2/subscriptions/${clientId}`, {
    headers: { 'x-trace-id': generateTraceId() },
  });
  return response.data;
};

const SUBSCRIPTION_MAPPERS_BY_PROVIDER = {
  jussub: mapJussubSubscription,
  jusbill: mapJusbillSubscription,
};

export const mapSubscriptionV2Response = (data) => {
  if (!data?.success) return null;

  const mapSubscription = SUBSCRIPTION_MAPPERS_BY_PROVIDER[data.provider];

  if (!mapSubscription) {
    console.error('Provider de assinatura não mapeado:', data.provider);
    toast.error('Não foi possível carregar os dados da assinatura do cliente.');
    return null;
  }

  return mapSubscription(data);
};

// Endpoint legado depende de a assinatura existir na base local; clientes só
// com assinatura no Jusbill não têm esse registro e recebem 404. O fallback
// v2 cancela direto no Jusbill, sem essa dependência.
const cancelSubscriptionV2 = async (clientId, reason, userId) => {
  const response = await axios.delete(
    `${config.app.adminBaseUrl}/clients/${clientId}/subscription`,
    {
      params: { reason_description: reason, from: `admin:${userId}` },
      headers: { 'x-trace-id': generateTraceId() },
    },
  );

  if (!response.data.success) {
    throw new Error(response.data.message || 'Erro ao cancelar assinatura.');
  }
};

export const cancelSubscription = async (clientId, userId, reason) => {
  let response;
  try {
    response = await axios.post(
      `${base}/subscription/cancel/${clientId}`,
      { values: { reason_description: reason, from: `admin:${userId}` } },
      { headers: { 'x-trace-id': generateTraceId() } },
    );
  } catch (error) {
    const status = error.response?.status;
    const isHttpError = Boolean(error.response) && (status < 200 || status >= 300);
    if (!isHttpError) throw error;
    return cancelSubscriptionV2(clientId, reason, userId);
  }

  if (!response.data.success) throw new Error('Erro ao cancelar assinatura.');
};


export const createPaymentLink = async (payload) => {
  const response = await axios.post(`${base}/payment-link/create`, payload);
  if (!response.data.success)
    throw new Error(response.data.message || 'Erro ao criar link de pagamento');
  return response.data;
};

export const createPaymentLinkV2 = async (payload) => {
  const response = await axios.post(`${base}/payment-link/create-v2`, payload);
  if (!response.data.success)
    throw new Error(response.data.message || 'Erro ao criar link de pagamento');
  return response.data;
};

export const getActivePaymentLink = async (clientId) => {
  const response = await axios.get(`${base}/payment-link/active/${clientId}`);
  return response.data;
};

export const getActivePaymentLinkV2 = async (clientId) => {
  const response = await axios.get(
    `${base}/payment-link/active-v2/${clientId}`,
  );
  return response.data;
};

export const sendPaymentLinkEmail = async (codeLink, email, url) => {
  const response = await axios.post(
    `${base}/payment-link/send-email/${codeLink}`,
    { email, url },
  );
  if (!response.data.success) throw new Error('Erro ao enviar email');
  return response.data;
};

export const sendPaymentLinkEmailV2 = async (codeLink, name, email, url) => {
  const response = await axios.post(
    `${base}/payment-link/send-email/v2/${codeLink}`,
    { name, email, url },
  );
  if (!response.data.success) throw new Error('Erro ao enviar email');
  return response.data;
};

export const expirePaymentLink = async (codeLink) => {
  const response = await axios.put(`${base}/payment-link/expire/${codeLink}`);
  if (!response.data.success) throw new Error('Erro ao expirar link');
  return response.data;
};

export const expirePaymentLinkV2 = async (codeLink) => {
  const response = await axios.put(
    `${base}/payment-link/expire-v2/${codeLink}`,
  );
  if (!response.data.success) throw new Error('Erro ao expirar link');
  return response.data;
};
